import clsx from "clsx";
import { Controller, useFormContext } from "react-hook-form";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

/** Minimal shape so onboarding, preferences, and the phone modal can share this field. */
type PhoneFormValues = {
	phoneNumber?: string | null;
};

type PhoneFieldsProps = {
	isOptional?: boolean;
};

const PhoneFields = ({ isOptional = true }: PhoneFieldsProps) => {
	const {
		control,
		formState: { errors },
	} = useFormContext<PhoneFormValues>();

	const errorMessage = errors.phoneNumber?.message as string | undefined;

	return (
		<div className="flex w-full flex-1 flex-col gap-2">
			<label
				htmlFor="phoneNumber"
				className="flex items-center justify-between font-medium text-gray-700 dark:text-slate-50"
			>
				Phone Number{" "}
				{errorMessage ? (
					<span className="font-normal text-red-500 dark:text-red-300">
						{errorMessage}
					</span>
				) : isOptional ? (
					<span className="font-normal text-slate-500 dark:text-slate-300">
						Optional
					</span>
				) : null}
			</label>

			<Controller
				name="phoneNumber"
				control={control}
				render={({ field: { value, onChange, onBlur, ref } }) => (
					<PhoneInput
						id="phoneNumber"
						international
						defaultCountry="US"
						countryCallingCodeEditable={false}
						value={value || undefined}
						onChange={(next) => onChange(next ?? "")}
						onBlur={onBlur}
						// Prefer `inputRef`: `numberInputProps.ref` overwrites the
						// library's ref and crashes on country select (.focus on null).
						inputRef={ref}
						className={clsx(
							"PhoneInput w-full",
							errorMessage &&
								"[&_.PhoneInputInput]:border-red-400 dark:[&_.PhoneInputInput]:border-red-300",
						)}
						numberInputProps={{
							className: "PhoneInputInput text-input w-full",
							placeholder: "(555) 123-4567",
							"aria-invalid": errorMessage ? "true" : "false",
						}}
					/>
				)}
			/>
		</div>
	);
};

export default PhoneFields;
